import Header from './header/Header';
import Footer from './footer/Footer';
import React, {Component} from 'react'
import { Container } from 'react-bootstrap';

class Layout extends Component {
    render() {
        return (
            <div style={{display: "flex", flexDirection: "column", minHeight: "100vh"}}>
                <div style={{marginTop:"4.5pc", flex: 1}}>
                    {this.props.data !=='/login' && <Header/>}
                    <Container fluid>
                        {this.props.children}
                    </Container>
                </div>
                {this.props.data !=='/login' && <Footer />}
            </div>
        )
    }
}

export default Layout;
